











import Vue from "vue";
import iwInputCheckbox from "../../buildingBlocks/InputCheckbox.vue";

export default Vue.extend({
    components: {
        iwInputCheckbox: iwInputCheckbox,
    },

    data: function() {
        return {
            pathInStore: "property.location.address.isPublic",
        };
    },

    computed: {
        /**
         * The API prop is `isPublic` while we need `isHidden`, hence the `!`
         * to reverse the logic in the getter and setter.
         */
        isHidden: {
            get: function(): boolean {
                return !this.$store.getters["FormModule/getValue"](this.pathInStore);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: !value
                });
            },
        },
    },
});
